export default __webpack_public_path__ + "media/images/faq_128-ac340b86fcbb3894962994c9c3059c1b.png";